import React from 'react';
import { Button } from '~/components';
import Modal from '~/components/Modal';

interface ConfirmationModalProps {
   closeModal: () => void
   contentElement: React.JSX.Element
   mutate: () => void
   status: string
   
   // Optional
   cancelText?: string
   confirmText?: string
   titleText?: string
}

export default function ConfirmationModal({ 
   cancelText = 'Cancel',
   closeModal, 
   confirmText = 'Confirm',
   contentElement, 
   mutate, 
   status,
   titleText = 'Confirmation' 
}: ConfirmationModalProps) {
   
  return (
    <Modal closeModal={closeModal}>
      <Modal.Title>
         {titleText}
      </Modal.Title>
      <Modal.Content>
         {contentElement}
      </Modal.Content>
      <Modal.Footer>
        <Button primary disabled={status === 'loading'} loading={status === 'loading'} onClick={() => mutate()}>{confirmText}</Button>
        <Button outlined disabled={status === 'loading'} primary onClick={status !== 'loading' ? closeModal : undefined}>{cancelText}</Button>
      </Modal.Footer>
    </Modal>
  );
}